import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import classnames from "classnames";
// javascript plugin that creates nice dropzones for files
import Dropzone from "dropzone";
// reactstrap components
import {
    UncontrolledAlert,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Label,
    Container,
    Row,
    Col,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { getAllCustomers } from "api/customerApiCall";
import { getAllProducts } from "api/productsApiCall";
// react plugin that creates an input with badges
// import Sidebar from 'components/Sidebar/Sidebar';
import { createInvoice } from 'api/invoiceApiCall';
import { useTranslation } from '../../../i18n/context';

Dropzone.autoDiscover = false;
function AddInvoice() {
    const [sidenavOpen, setSidenavOpen] = useState(true);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [allCustomers, setAllCustomers] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [discountError, setDiscountError] = useState('');
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        customer_name: '',
        customer_address: '',
        customer_country: '',
        customer_email: '',
        customer_phone: '',
        country_code: '',
        invoice_date: '',
        discount: '',
        subtotal: '',
        payout_number: '',
        account_name: '',
        provider_name: '',

    });


    const francophoneCountries = [
        { code: 'gh', name: 'Ghana', dialCode: '233' },
        { code: 'BEN', name: 'Benin', dialCode: '229' },
        { code: 'TZA', name: 'Tanzania', dialCode: '255' },
        { code: 'BFA', name: 'Burkina Faso', dialCode: '226' },
        { code: 'BDI', name: 'Burundi', dialCode: '257' },
        { code: 'CMR', name: 'Cameroon', dialCode: '237' },
        { code: 'CAN', name: 'Canada', dialCode: '1' },
        { code: 'CAF', name: 'Central African Republic', dialCode: '236' },
        { code: 'TCD', name: 'Chad', dialCode: '235' },
        { code: 'COM', name: 'Comoros', dialCode: '269' },
        { code: 'COG', name: 'Congo', dialCode: '242' },
        { code: 'COD', name: 'DR Congo', dialCode: '243' },
        { code: 'DJI', name: 'Djibouti', dialCode: '253' },
        { code: 'FRA', name: 'France', dialCode: '33' },
        { code: 'GUF', name: 'French Guiana', dialCode: '594' },
        { code: 'PYF', name: 'French Polynesia', dialCode: '689' },
        { code: 'GAB', name: 'Gabon', dialCode: '241' },
        { code: 'GIN', name: 'Guinea', dialCode: '224' },
        { code: 'HTI', name: 'Haiti', dialCode: '509' },
        { code: 'CIV', name: "Côte d'Ivoire", dialCode: '225' },
        { code: 'LUX', name: 'Luxembourg', dialCode: '352' },
        { code: 'MDG', name: 'Madagascar', dialCode: '261' },
        { code: 'MLI', name: 'Mali', dialCode: '223' },
        { code: 'MRT', name: 'Mauritania', dialCode: '222' },
        { code: 'MCO', name: 'Monaco', dialCode: '377' },
        { code: 'NER', name: 'Niger', dialCode: '227' },
        { code: 'ng', name: 'Nigeria', dialCode: '234' },
        { code: 'RWA', name: 'Rwanda', dialCode: '250' },
        { code: 'SEN', name: 'Senegal', dialCode: '221' },
        { code: 'SYC', name: 'Seychelles', dialCode: '248' },
        { code: 'TGO', name: 'Togo', dialCode: '228' },
        { code: 'VUT', name: 'Vanuatu', dialCode: '678' }
    ];

    const formatPhoneWithCountryCode = (phone, country) => {
        const countryInfo = francophoneCountries.find(c => c.name === country);
        if (!countryInfo) return phone;
        return `${countryInfo.dialCode}${phone}`; // Note: no '+' symbol
    };

    const getCountryCode = (country) => {
        const countryInfo = francophoneCountries.find(c => c.name === country);
        return countryInfo ? countryInfo.code : '';
    };

    const handleCustomerChange = (e) => {
        const customerId = e.target.value;
        const customer = allCustomers.find(c => c._id === customerId);
        if (customer) {
            setSelectedCustomer(customer);

            // Format the phone number with country code but without '+'
            const formattedPhone = formatPhoneWithCountryCode(
                customer.customer_phone,
                customer.customer_country
            );

            // Get the country code
            const countryCode = getCountryCode(customer.customer_country);

            setFormData({
                ...formData,
                customer_name: customer.customer_name,
                customer_address: customer.customer_address,
                customer_country: customer.customer_country,
                customer_email: customer.customer_email,
                customer_phone: formattedPhone,
                country_code: countryCode,
            });
        } else {
            console.error("Selected customer not found");
        }
    };


    const [error, setError] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        // Calculate subtotal based on products
        const productTotal = selectedProducts.reduce((total, product) => {
            return total + (parseFloat(product.price) || 0) * (parseInt(product.quantity, 10) || 1);
        }, 0);

        // Parse discount, defaulting to 0 if invalid
        const discountAmount = parseFloat(formData.discount) || 0;

        // Validate discount
        if (discountAmount > productTotal) {
            setDiscountError('Discount cannot exceed the total price');
        } else {
            setDiscountError('');
        }

        // Calculate final subtotal
        const subtotal = Math.max(productTotal - discountAmount, 0);

        setFormData(prevData => ({
            ...prevData,
            subtotal: subtotal.toFixed(2)
        }));
    }, [selectedProducts, formData.discount]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prevData => {
            const newData = { ...prevData, [name]: value };

            if (name === 'discount') {
                const productTotal = selectedProducts.reduce((total, product) => {
                    return total + (parseFloat(product.price) || 0) * (parseInt(product.quantity, 10) || 1);
                }, 0);

                if (parseFloat(value) > productTotal) {
                    setDiscountError('Discount cannot exceed the total price');
                } else {
                    setDiscountError('');
                }
            }

            return newData;
        });
    };


    const handleProductChange = (e) => {
        const productId = e.target.value;
        const product = allProducts.find(p => p._id === productId);
        if (product) {
            setSelectedProducts(prevProducts => [...prevProducts, { ...product, quantity: 1 }]);
        } else {
            console.error("Selected product not found");
        }
    };

    const handleQuantityChange = (index, e) => {
        const { value } = e.target;
        const updatedProducts = [...selectedProducts];
        updatedProducts[index].quantity = value;
        setSelectedProducts(updatedProducts);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const updatedFormData = {
            ...formData,
            customer_country: formData.customer_country || '',
            country_code: formData.country_code || '', // Include country_code in the submission
            products: selectedProducts.map(product => ({
                product_name: product.product_name,
                price: product.price,
                quantity: product.quantity
            })),
        };

        const [errorInvoicesCall, successInvoiceCall] = await createInvoice(updatedFormData);
        if (errorInvoicesCall || !successInvoiceCall) {
            setError(errorInvoicesCall.message || "An unknown error occurred.");
            setShowErrorAlert(true);
        } else {
            setShowSuccessAlert(true);
            setTimeout(() => {
                navigate('/admin/invoice');
            }, 2000);
        }
    };




    useEffect(() => {
        const fetchCustomers = async () => {
            const [errorCustomersCall, successCustomerCall] = await getAllCustomers({});
            if (errorCustomersCall || !successCustomerCall) {
                setAllCustomers([]);
            } else {
                setAllCustomers(successCustomerCall);
            }
        };

        const fetchProducts = async () => {
            const [errorProductsCall, successProductsCall] = await getAllProducts({});
            if (errorProductsCall || !successProductsCall) {
                setAllProducts([]);
            } else {
                setAllProducts(successProductsCall);
            }
        };

        fetchCustomers();
        fetchProducts();
    }, []);

    return (
        <>
            <SimpleHeader name={t('invoice.add_invoice')} />
            <Container className="mt--6" fluid>
                <Row>
                    <Col lg="12">
                        <div className="card-wrapper">
                            <Card>
                                <CardHeader>
                                    <h3 className="mb-0">{t('invoice.add_invoice')}</h3>
                                    {showSuccessAlert && (
                                        <UncontrolledAlert color="success">
                                            <strong>{t('profile.success')}</strong> {t('invoice.successfull')}
                                        </UncontrolledAlert>
                                    )}

                                    {showErrorAlert && (
                                        <UncontrolledAlert color="danger">
                                            <strong>{t('profile.error')}</strong> {t('invoice.not_successful')}
                                        </UncontrolledAlert>
                                    )}
                                </CardHeader>
                                <CardBody>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md="8">
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-user" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input type="select" onChange={handleCustomerChange}>
                                                            <option value="">{t('invoice.select_customer')}</option>
                                                            {allCustomers.map((customerData, index) => (
                                                                <option key={index} value={customerData._id}>
                                                                    {customerData?.customer_name}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-country" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder={t('invoice.customer_country')}
                                                            type="text"
                                                            name="customer_country"
                                                            id="customer_country"
                                                            value={formData.customer_country}
                                                            onChange={handleInputChange}
                                                            required
                                                            readOnly
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="3">
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-user" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder={t('invoice.customer_name')}
                                                            type="text"
                                                            name="customer_name"
                                                            id="customer_name"
                                                            value={formData.customer_name}
                                                            onChange={handleInputChange}
                                                            required
                                                            readOnly
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-globe" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder={t('invoice.customer_address')}
                                                            type="text"
                                                            name="customer_address"
                                                            id="customer_address"
                                                            value={formData.customer_address}
                                                            onChange={handleInputChange}
                                                            required
                                                            readOnly
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-mail" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Email"
                                                            type="email"
                                                            name="customer_email"
                                                            id="customer_email"
                                                            value={formData.customer_email}
                                                            onChange={handleInputChange}
                                                            required
                                                            readOnly
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-phone" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder={t('invoice.customer_phone')}
                                                            type="text"
                                                            name="customer_phone"
                                                            id="customer_phone"
                                                            value={formData.customer_phone}
                                                            onChange={handleInputChange}
                                                            required
                                                            readOnly
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <FormGroup className="row">
                                            <Col md="11">
                                                <Input type="select" onChange={handleProductChange}>
                                                    <option value="">{t('invoice.select_product')}</option>
                                                    {allProducts.map((productData, index) => (
                                                        <option key={index} value={productData._id}>
                                                            {productData?.product_name} - {productData?.currency} {productData?.price}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                        </FormGroup>

                                        {selectedProducts.map((product, index) => (
                                            <Row key={index}>
                                                <Col md="6">
                                                    <label><small>{t('product.product_name')}</small></label>

                                                    <FormGroup>
                                                        <InputGroup className={classnames("input-group-merge")}>
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="fas fa-box" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input
                                                                placeholder="Product name"
                                                                type="text"
                                                                name={`product_name_${index}`}
                                                                id={`product_name_${index}`}
                                                                value={product.product_name}
                                                                readOnly
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3">
                                                    <FormGroup>
                                                        <label><small>{t('invoice.quantity')}</small></label>

                                                        <InputGroup className={classnames("input-group-merge")}>
                                                            <Input
                                                                placeholder="Quantity"
                                                                type="number"
                                                                name={`quantity_${index}`}
                                                                id={`quantity_${index}`}
                                                                value={product.quantity}
                                                                onChange={(e) => handleQuantityChange(index, e)}
                                                                required
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="3" className="mb-2">
                                                    <label><small>{t('product.price')}</small></label>

                                                    <FormGroup>
                                                        <InputGroup className={classnames("input-group-merge")}>
                                                            <Input
                                                                placeholder="Price"
                                                                type="text"
                                                                name={`price_${index}`}
                                                                id={`price_${index}`}
                                                                value={product.price}
                                                                readOnly
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        ))}

                                        <Row>
                                            <Col md="4">
                                                <label><small>Date</small></label>

                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-calendar" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Date"
                                                            type="date"
                                                            name="invoice_date"
                                                            id="invoice_date"
                                                            value={formData.invoice_date}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <label><small>{t('invoice.discount')}</small></label>

                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-minus" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder={t('invoice.discount')}
                                                            type="text"
                                                            name="discount"
                                                            id="discount"
                                                            value={formData.discount}
                                                            onChange={handleInputChange}
                                                            invalid={!!discountError}
                                                        // required
                                                        />
                                                        {discountError && <div className="text-danger">{discountError}</div>}
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>

                                            <Col md="4">
                                                <label><small>{t('invoice.subtotal')}</small></label>

                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                {/* <i className="fas fa-cedi-sign" /> */}
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder="Subtotal"
                                                            type="text"
                                                            name="subtotal"
                                                            id="subtotal"
                                                            value={formData.subtotal}
                                                            readOnly
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>


                                        </Row>

                                        <Row>
                                            <Col md="4">
                                                <label><small>{t('common.momo')}</small></label>
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-phone" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder={t('common.payout_number')}
                                                            type="number"
                                                            name="payout_number"
                                                            id="payout_number"
                                                            value={formData.payout_number}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>

                                            <Col md="4">
                                                <label><small>{t('common.momo_name')}</small></label>
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-user" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            placeholder={t('common.enter_account')}
                                                            type="text"
                                                            name="account_name"
                                                            id="account_name"
                                                            value={formData.account_name}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>

                                            <Col md="4">
                                                <label><small>{t('common.provider')}</small></label>
                                                <FormGroup>
                                                    <InputGroup className={classnames("input-group-merge")}>
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="fas fa-building" />
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Input
                                                            type="select"
                                                            name="provider_name"
                                                            id="provider_name"
                                                            value={formData.provider_name}
                                                            onChange={handleInputChange}
                                                            required
                                                        >
                                                            <option value="">{t('common.select_provider')}</option>
                                                            <option value="MTN">MTNGH</option>
                                                            <option value="VOD">TelecelGH</option>
                                                            <option value="ATL">AT-MoneyGH</option>
                                                        </Input>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>


                                        <Button className="btn-icon" color="primary" type="submit" disabled={!!discountError}>
                                            <span className="btn-inner--text">{t('profile.submit')}</span>
                                        </Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container >
            {
                // sidenavOpen ? (
                //     <div className="backdrop d-xl-none" onClick={toggleSidenav} />
                // ) : null
            }
        </>
    );
}

export default AddInvoice;


